"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormHelper = exports.DatePickerStyled = exports.MaskInputStyled = exports.InputStyled = exports.FormItemFormulary = exports.FormItemFormularyRequired = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const antd_1 = require("antd");
const antd_mask_input_1 = __importDefault(require("antd-mask-input"));
exports.FormItemFormularyRequired = (0, styled_components_1.default)(antd_1.Form.Item) `
  label {
    color: #c31c4a;
    font-weight: 500;
  }
`;
exports.FormItemFormulary = (0, styled_components_1.default)(antd_1.Form.Item) `
  label {
    color: #000;
    font-weight: 500;
  }
`;
exports.InputStyled = (0, styled_components_1.default)(antd_1.Input) `
  border-radius: 5px;
  height: 43px;
`;
exports.MaskInputStyled = (0, styled_components_1.default)(antd_mask_input_1.default) `
  border-radius: 5px;
  height: 43px;
`;
exports.DatePickerStyled = (0, styled_components_1.default)(antd_1.DatePicker) `
  flex: 1;
  width: 100%;
  border-radius: 5px;
  height: 43px;
`;
exports.FormHelper = styled_components_1.default.span `
  color: #c31c4a;
  font-weight: 400;
`;
